import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../services/axois";
import { toast } from 'react-toastify';
import { removeUserSession, setToken } from "../../../utility/genricFunction";
import { setPageModeOtp, setUserPhone, setUserToken } from "../../slice/auth/authenticationSlice";
import { API_ROUTES } from "../../../utility/api.routes";
import { getArea, getCity, getState } from "../masterDataSet/masterDataSet.builder";
import { getBranch } from "../branch/branch.builder";
import axios from "axios";


const config = {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'post',
  };

// Define the login async thunk for signin-password
export const login = createAsyncThunk('auth/login', async ({ userEmail, userPassword,navigate },{dispatch}) => {
  try {
      const response = await apiClient.post('auth/signin-email', { userEmail, userPassword }, config);
      if(response.status == 200){
        // setUser(response.data.result)
        // dispatch(setUserData(response?.data))
        dispatch(setUserToken(response?.data?.result?.accessToken))
        // setToken(response?.data?.result?.accessToken)
      setToken(response.data.result);
        //uncomment later
        dispatch(getState())
        dispatch(getCity())
        dispatch(getArea()) 
        dispatch(getUserList())
        dispatch(getBranch('active'))
        navigate('/dashboard')
    }
    return response.data;
  } catch (error) {
      toast.error(error?.response?.data?.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
      })
      // toast.error(error.response.data.message)
      throw error.response.data;
  }
});
  
  // Define the login async thunk for signin-otp
  export const loginWithOTP = createAsyncThunk('auth/loginWithOTP', async ({ email ,navigate},{dispatch}) => {
    try {
      const response = await apiClient.post('auth/signin-otp', { email }, config);
      if(response){
        dispatch(setPageModeOtp('otp'))
        navigate('/verify-otp')
      }
      return response.data;
    } catch (error) {
  
      toast.error(error.response.data.message)
      throw error.response.data;
    }
  });
  
  export const verifyWithOTP = createAsyncThunk('auth/verifyWithOTP', async ({ otp, token,navigate },{dispatch}) => {
    try {
      const response = await apiClient.post('auth/verify-otp', {  otp, token  }, config);
      if(response){
        // setUser(response.data.result)
        // dispatch(setUserData(response?.data))
        dispatch(setUserToken(response?.data?.result?.accessToken))
      setToken(response.data.result);
        dispatch(getState())
        dispatch(getCity())
        dispatch(getArea())
        dispatch(getUserList())
        dispatch(setUserPhone(null))
        dispatch(getBranch('active'))
       navigate('/dashboard')
      }
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message)
      throw error.response.data;
    }
  
  });
  
  export const forgotPassword =  createAsyncThunk('auth/forgotPassword', async ({ email,navigate,setPageMode }) =>{
    try {
      const response = await apiClient.post('auth/forgot-password', {  email  }, config);
      if(response){
        setPageMode('password')
        navigate('/login-email')
      }
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message)
      throw error.response.data;
    }
  
  })
  
  export const resetPassword = createAsyncThunk(
    'auth/resetPassword',
    async ({ newPassword , confirmPassword, token, navigate}) => {
      try {
        const config = {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, // Set the authorization token in the headers
          },
        };
  
      const response = await apiClient.post('auth/reset-password', {  newPassword ,confirmPassword, }, config);
      if(response){
        navigate('/login')
        toast.success(response.data.message)
      }
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message)
      throw error.response.data;
    }
  })

  export const logout =  createAsyncThunk('auth/logout', async ({navigate},{dispatch}) =>{
    try {
      const response = await apiClient.post('auth/logout');
      if(response?.data?.status){
        removeUserSession(dispatch)
        navigate('/login')
      }
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message)
      throw error.response.data;
    }
  
  })



  
  export const getUserList =   createAsyncThunk('auth/getUserList', async (userRole , {getState}) =>{
    try {
      const state = getState()
      const url = API_ROUTES.AUTH.GET_USERS(state.auth.userRole)
      const response = await apiClient.get(url);
      return response.data.result;
    } catch (error) {
      toast.error(error.response.data.message)
      throw error.response.data;
    }
  
  })


  export const refreshToken =  async (refreshToken ) => {
    try {
      // eslint-disable-next-line no-undef
      const response = await axios.post(`${process.env.REACT_APP_LIVE_URL}/auth/refresh`, { refreshToken },config);

      return response
      // setToken(newToken);
      // dispatch(setUserToken(response?.data?.result?.accessToken))

    } catch (error) {
      return error
    }
  };